import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from "react";
import classNames from "classnames";
import { useOutsideClick } from "@jti/ui/hooks/useOutsideClick";
import { ProductMultiPacksHeader } from "./ProductMultipacksHeader";
import { ProductMultiPacksItem } from "./ProductMultipacksItem";
import "./ProductMultipacks.scss";
export const ProductMultipacks = ({ currentProduct, multiPackProducts, isMultiPackEnabled }) => {
    const dropdownRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    useOutsideClick(dropdownRef, () => {
        setIsOpen(false);
    });
    if (!isMultiPackEnabled) {
        return _jsx(React.Fragment, {});
    }
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };
    const className = classNames("product-multipacks", {
        "product-multipacks--open": isOpen,
    });
    return (_jsx("div", { className: "product-multipacks__wrapper", children: _jsxs("div", { ref: dropdownRef, "data-testid": "product-multipacks", className: className, onClick: toggleDropdown, children: [_jsx(ProductMultiPacksHeader, { item: currentProduct }), _jsx("ul", { className: "product-multipacks__list", children: multiPackProducts?.map((product) => (_jsx(ProductMultiPacksItem, { item: product }, product.sku))) })] }) }));
};
//# sourceMappingURL=ProductMultipacks.js.map